module.exports = __webpack_public_path__ + "img/fig19.463a929a.jpg";